import { NgModule, ErrorHandler, inject, provideAppInitializer } from '@angular/core';

import { ConfirmationService } from 'primeng/api';

import { HisCoreSharedModule } from './his-core-shared.module';
import { HisErrorHandler } from './service/backend/his-errorhandler.service';
import { HisCoreInitializerService } from './service/base/his-core-initializer.service';

// Zusätzlich zu en-US unterstützte Locales für Lokalisierung (z.B. in DatePipe)
export function initializeLocaleData( initializer: HisCoreInitializerService ) {
    const x = () => initializer.initializeLocaleData();
    return x;
}

@NgModule( {
    imports: [
        HisCoreSharedModule
    ],
    declarations: [
    ],
    exports: [
        HisCoreSharedModule
    ],
    providers: [
        ConfirmationService,
        { provide: ErrorHandler, useClass: HisErrorHandler },
        provideAppInitializer( () => {
            const initializerFn = ( initializeLocaleData )( inject( HisCoreInitializerService ) );
            return initializerFn();
        } ),
    ],
} )

export class HisCoreCoreModule {
}
